




























import { ChangeSettings } from "@/api/configuration";
import AbpBase from "@/lib/abpbase";
import ajax from "@/lib/ajax";
import util from "@/lib/util";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: any;

  tempContent: string = "";
  readonly settingName = "MobileMsgTempForPatient";

  created() {
    this.tempContent = util.abp.setting.get(this.settingName);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  cancel() {
    this.$emit("input", false);
  }

  async save() {
    console.log("test");
    if (!this.tempContent) {
      this.$Message.error("请输入模板内容");
      return;
    }
    let payload = {
      settings: [
        {
          name: this.settingName,
          value: this.tempContent,
        },
      ],
    };
    let res = await ChangeSettings(payload);
    if (res.status == 1) {
      await this.reloadSettings();
      this.$emit("input", false);
    }
  }

  async reloadSettings() {
    ajax.get("/AbpUserConfiguration/GetAll").then((data) => {
      util.abp = util.extend(true, util.abp, data.data.result);
      console.log("util.abp.setting已刷新");
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/mobileMessage/setTemplate.vue